import React from 'react';
import { FiGithub, FiLinkedin, FiArrowUp } from 'react-icons/fi';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <p className="footer-copyright">&copy; {currentYear} Théophile Yvars</p>

          <div className="footer-actions">
            <div className="social-links">
              <a href="https://github.com/Theophile-Yvars" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="GitHub"><FiGithub /></a>
              <a href="https://www.linkedin.com/in/th%C3%A9ophile-yvars-72312415a/" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn"><FiLinkedin /></a>
            </div>
            <button onClick={scrollToTop} className="back-to-top" aria-label="Retour en haut">
              <FiArrowUp />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;